/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { EstimationTile, SummaryEstimation } from '@bingads-webui-campaign-react/recommendation-estimation-tile';
import {
  ActionTable,
  BingMapView,
  AdsPreview,
} from '@bingads-webui-campaign-react/recommendation-visuals';
import { AdvisorChart } from '@bingads-webui-campaign-react/advisor-chart';
import { CouponTagNew } from '@bingads-webui-react/feature-adoption-coupon';
import {
  VISUAL_TYPES,
  isCompetition,
  NOT_SUPPORT_DOWNLOAD_TYPES,
  SUMMARY_LEVELS,
  withTrack,
  getChannel,
  APPLY_ACTION_TYPES,
  withAdsAutoApply,
  recommendationInProductUpdateConfigs,
  RECOMMENDATION_TYPES,
  NOT_SUPPORT_DISMISS_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import {
  isInProductUpdateBannerAvailable,
  InProdUpdateNotificationBanner,
  handleRecommendationNotification,
  WarnNotificationBanner,
} from '@bingads-webui-campaign/recommendation-notification';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';
import { StyledRecommendationAutpApplyBanner } from '@bingads-webui-campaign-react/recommendation-auto-apply-banner';
import { RecommendationOptimizationScoreTag } from '@bingads-webui-campaign-react/recommendation-os-tag';
import { SummaryHeader } from './summary-header';
import { SummaryFooter } from './summary-footer';
import { SamplePanel } from './sample-panel';
import { OverallOptimizationScore } from './optimization-score';

class FuncWithName {
  constructor(name, func, disabled = false) {
    this.name = name;
    this.func = func;
    this.disabled = disabled;
  }
}

class summaryCard extends React.PureComponent {
  static propTypes = {
    summary: PropTypes.shape({
      description: PropTypes.string.isRequired,
      pitching: PropTypes.string.isRequired,
      helpId: PropTypes.string.isRequired,
      isSeasonal: PropTypes.bool.isRequired,
      title: PropTypes.string.isRequired,
      iconClasses: PropTypes.string.isRequired,
      iconClassesVNext: PropTypes.string.isRequired,
      estimates: PropTypes.shape({
        primaryIncrease: PropTypes.string.isRequired,
      }),
      coupon: PropTypes.object,
      isNrt: PropTypes.bool,
      hasAIAssetRecommendation: PropTypes.bool,
      linkType: PropTypes.string,
      thirdPartyInfos: PropTypes.arrayOf(PropTypes.shape({
        Level: PropTypes.number,
        ThirdPartyName: PropTypes.string,
      })),
    }).isRequired,
    sample: PropTypes.shape({
      visualData: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
      ]).isRequired,
    }).isRequired,
    onFeedbackModalOpen: PropTypes.func,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    locationMap: PropTypes.func.isRequired,
    reload: PropTypes.func,
    type: PropTypes.string.isRequired,
    version: PropTypes.number.isRequired,
    level: PropTypes.string,
    logOpportunityEvent: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    onDownload: PropTypes.func,
    handleHideCard: PropTypes.func,
    currentActivity: PropTypes.objectOf(PropTypes.any).isRequired,
    context: PropTypes.shape({
      Source: PropTypes.string,
      Level: PropTypes.string.isRequired,
      Category: PropTypes.string,
    }),
    guid: PropTypes.string,
    perfMarker: PropTypes.shape({
      willInit: PropTypes.func.isRequired,
      willRender: PropTypes.func.isRequired,
      done: PropTypes.func.isRequired,
    }),
    isInlineView: PropTypes.bool,
    scope: PropTypes.shape({
      customerId: PropTypes.number,
      accountId: PropTypes.number,
      advertiserCustomerId: PropTypes.number,
      levelAt: PropTypes.string,
    }),
    odata: PropTypes.PropTypes.shape({
      get: PropTypes.func.isRequired,
    }),
    preferencesService: PropTypes.objectOf(PropTypes.any),
    appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
    permissions: PropTypes.objectOf(PropTypes.any),
    isMCC: PropTypes.bool,
    optimizationScore: PropTypes.number,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    isOverviewPage: PropTypes.bool,
    category: PropTypes.string,
    isOptimizationScoreOn: PropTypes.bool,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    track: PropTypes.func.isRequired,
    campaignAdGroups: PropTypes.arrayOf(PropTypes.object),
    isFromDismissTab: PropTypes.bool,
    optInStatus: PropTypes.bool,
    applyDate: PropTypes.number,
    recommendationsCount: PropTypes.number,
    isFromSummary: PropTypes.bool,
    classes: PropTypes.objectOf(PropTypes.string),
    initializeMiniGrid: PropTypes.func,
    showAutoApplyBanner: PropTypes.bool,
    isAutoApplyRecommendationEnabled: PropTypes.bool,
    viewSettings: PropTypes.func,
    isAutoApplyOptIn: PropTypes.bool,
  };

  static defaultProps = {
    level: null,
    onDownload: null,
    onFeedbackModalOpen: _.noop,
    reload: _.noop,
    readOnly: undefined,
    campaignAdGroups: undefined,
    handleHideCard: _.noop,
    perfMarker: {
      willInit: _.noop,
      willRender: _.noop,
      done: _.noop,
    },
    context: null,
    guid: null,
    isInlineView: false,
    scope: null,
    odata: null,
    preferencesService: null,
    permissions: {},
    isMCC: false,
    optimizationScore: null,
    overallOptimizationScoreBar: null,
    isOverviewPage: false,
    category: null,
    isOptimizationScoreOn: false,
    newI18n: {
      getString: _.noop,
    },
    isFromDismissTab: false,
    optInStatus: false,
    applyDate: 0,
    isFromSummary: false,
    initializeMiniGrid: _.noop,
    classes: {},
    recommendationsCount: 0,
    showAutoApplyBanner: false,
    isAutoApplyRecommendationEnabled: false,
    viewSettings: _.noop,
    isAutoApplyOptIn: false,
  };

  constructor(props) {
    super(props);
    props.perfMarker.willInit();
  }

  componentDidMount() {
    this.props.perfMarker.done();
  }

  getHeaderMenuItems = () => {
    const {
      permissions,
      isInlineView,
      i18n,
      isOptimizationScoreOn,
      readOnly,
      isFromDismissTab,
      newI18n,
    } = this.props;

    const isInProductFeedbackLoopOn = permissions.IsRecommendationInProductFeedbackLoopEnabled;
    const { levelAt } = this.props.scope;
    const headerMenuItems = [];
    const onDownload = _.contains(NOT_SUPPORT_DOWNLOAD_TYPES, this.props.type) ?
      null : this.props.onDownload && this.handleDownload;

    if (isInlineView) {
      if (levelAt === SUMMARY_LEVELS.CAMPAIGN) {
        headerMenuItems.push(new FuncWithName(i18n.getString('Summary_Card_Context_Menu_Hide_In_Campaign'), () => this.handleHideCard(SUMMARY_LEVELS.CAMPAIGN)));
      }
      if (levelAt === SUMMARY_LEVELS.ADGROUP) {
        headerMenuItems.push(new FuncWithName(i18n.getString('Summary_Card_Context_Menu_Hide_In_AdGroup'), () => this.handleHideCard(SUMMARY_LEVELS.ADGROUP)));
      }
      headerMenuItems.push(new FuncWithName(i18n.getString('Summary_Card_Context_Menu_Hide_In_Account'), () => this.handleHideCard(SUMMARY_LEVELS.ACCOUNT)));
    }

    if (!_.isNull(onDownload)) {
      headerMenuItems.push(new FuncWithName(i18n.getString('Summary_Card_Context_Menu_Download'), onDownload));
    }

    if (!_.contains(NOT_SUPPORT_DISMISS_TYPES, this.props.type)) {
      if (isInProductFeedbackLoopOn || isOptimizationScoreOn) {
        if (isFromDismissTab) {
          headerMenuItems.push(new FuncWithName(newI18n.getString(_TL_('Undismiss all')), this.handleUndismissAll, this.props.readOnly));
        } else {
          headerMenuItems.push(new FuncWithName(i18n.getString('Details_View_Dismiss_All'), this.handleDismissAll, readOnly));
        }
      } else {
        headerMenuItems.push(new FuncWithName(i18n.getString('Summary_Card_Context_Menu_Reject'), this.handleReject, readOnly));
      }
    }

    if (!isFromDismissTab) {
      headerMenuItems.push(new FuncWithName(i18n.getString('Summary_Card_Context_Menu_Feedback'), this.handleFeedback, readOnly));
    }

    return headerMenuItems;
  };

  handleSubmit(isProvideFeedbackOnly, isDismissAll = false) {
    this.props.onFeedbackModalOpen({
      recommendationDescription: this.props.summary.title,
      isProvideFeedbackOnly,
      isDismissAll,
      type: this.props.type,
      applyOpportunitiesLevel: this.props.level,
      context: this.props.context,
    });
  }

  handleDownload = () => {
    this.props.onDownload(this.props.type, this.props.version);
  };

  handleReject = () => {
    this.handleSubmit(false);
  };

  handleDismissAll = () => {
    this.handleSubmit(false, true);
  };

  handleUndismissAll = () => {
    const {
      context,
      type,
      isInlineView,
      level,
      guid,
      isMCC,
    } = this.props;

    this.props.track({
      type: this.props.type,
      campaignAdGroups: this.props.campaignAdGroups,
      channel: getChannel(type, isInlineView, isMCC),
      userAction: APPLY_ACTION_TYPES.UNDISMISS,
      applyOpportunitiesLevel: level,
      context: _.defaults({}, context, { trackId: generateGuid(), ApplyMode: 'All' }),
      guid,
      withAll: true,
      handleRecommendationNotification,
    });
  };

  handleFeedback = () => {
    this.handleSubmit(true);
  };

  handleHideCard = (levelAt) => {
    this.props.handleHideCard(this.props.type, levelAt);
  };

  render() {
    this.props.perfMarker.willRender();
    const {
      sample: {
        visualType,
        visualData,
      },
      locationMap,
      i18n,
      type,
      preferencesService,
      permissions,
      summary,
      isOverviewPage,
      isOptimizationScoreOn,
      context,
      newI18n,
      isFromDismissTab,
      optInStatus,
      scope,
      applyDate,
      recommendationsCount,
      appConfig,
      odata,
      isFromSummary,
      classes,
      initializeMiniGrid,
      showAutoApplyBanner,
      isAutoApplyRecommendationEnabled,
      overallOptimizationScoreBar,
      viewSettings,
      isMCC,
      isAutoApplyOptIn,
    } = this.props;
    const inProductUpdateConfig = recommendationInProductUpdateConfigs[type];
    let chart;
    switch (visualType) {
      case VISUAL_TYPES.COLUMN_CHART:
      case VISUAL_TYPES.LINE_CHART:
      case VISUAL_TYPES.LINE_WEEKLY_CHART:
      case VISUAL_TYPES.LINE_COLUMN_CHART:
        chart = (<AdvisorChart
          i18n={i18n}
          type="RecommendationCard"
          subType={visualType}
          {...visualData}
        />);
        break;
      case VISUAL_TYPES.TABLE:
        chart = <ActionTable {...visualData} />;
        break;
      case VISUAL_TYPES.MAP:
        chart = <BingMapView locationMap={locationMap} data={visualData} />;
        break;
      case VISUAL_TYPES.ADS_PREVIEW:
        chart = <AdsPreview {...visualData} i18n={i18n} newI18n={newI18n} />;
        break;
      default:
        break;
    }

    const {
      description,
      pitching,
      helpId,
      isSeasonal,
      estimates,
      coupon,
      linkType,
      thirdPartyInfos,
    } = this.props.summary;

    // value for the notification banner
    const tagManager = thirdPartyInfos && thirdPartyInfos.length > 0 ?
      thirdPartyInfos[0].ThirdPartyName : null;
    const additionalArgs = _.isNull(tagManager) ? {} : { tagManager };

    const showSummarySample = (isCompetition(this.props.type) || (
      !_.isEmpty(this.props.sample.visualData) &&
      !_.isEmpty(this.props.sample.visualData.headers))) && (!this.props.isInlineView)
      && (!isOverviewPage || type !== RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS);
    const showFooterInDescription = this.props.isInlineView;
    const showEstimates = estimates && estimates.showEstimates && !this.props.isInlineView;

    const headerMenuItems = this.getHeaderMenuItems();

    const header = (
      <div className="summary-header">
        <SummaryHeader
          headerMenuItems={headerMenuItems}
          i18n={i18n}
          isInlineView={this.props.isInlineView}
          {...this.props.summary}
          coupon={coupon}
          permissions={this.props.permissions}
          optimizationScore={this.props.optimizationScore}
          overallOptimizationScoreBar={overallOptimizationScoreBar}
          isOptimizationScoreOn={isOptimizationScoreOn}
          context={context}
          newI18n={newI18n}
          isFromDismissTab={isFromDismissTab}
          type={type}
        />
      </div>
    );

    const banner = (
      <div className="summary-banner">
        {estimates && estimates.showEstimates && isSeasonal &&
          <div className="summary-banner-title">
            {i18n.getString('Summary_Card_Banner_Seasonal_Recommendation')}
          </div>
        }
      </div>
    );

    const summaryEstimates = (
      <div className="summary-estimates">
        <EstimationTile {...estimates} />
      </div>
    );

    const summaryOptimizationScore = (
      <div className="summary-overall-optimization-score">
        <OverallOptimizationScore
          overallOptimizationScoreBar={overallOptimizationScoreBar}
          newI18n={newI18n}
          scope={scope}
        />
      </div>
    );

    const summaryEstimation = (
      <div className="summary-estimation">
        <SummaryEstimation {...estimates} />
      </div>
    );

    const sample = (
      <div className="summary-sample">
        <SamplePanel {...this.props.sample} >
          {chart}
        </SamplePanel>
      </div>
    );

    const footer = (
      <div className="summary-footer">
        <SummaryFooter {...this.props} />
      </div>
    );

    let overviewEstimationOrSummary = null;
    if (isOverviewPage) {
      if (isOptimizationScoreOn && overallOptimizationScoreBar) {
        overviewEstimationOrSummary = summaryOptimizationScore;
      } else if (showEstimates) {
        overviewEstimationOrSummary = summaryEstimates;
      }
    }

    let AutoApplyBanner;
    if (showAutoApplyBanner) {
      AutoApplyBanner = isAutoApplyRecommendationEnabled ?
        StyledRecommendationAutpApplyBanner : withAdsAutoApply(StyledRecommendationAutpApplyBanner);
    }

    const summaryDescription = (
      <div className="summary-info" style={!showEstimates && isOverviewPage && !isOptimizationScoreOn ? { gridColumn: 1 } : {}}>
        {isOverviewPage
        && coupon && <CouponTagNew coupon={coupon} i18n={i18n} />}
        <div
          className={`summary-description ${isOptimizationScoreOn && isOverviewPage && 'summary-description-os'}`}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {isOptimizationScoreOn && isOverviewPage && !_.isEmpty(overallOptimizationScoreBar) &&
          <RecommendationOptimizationScoreTag
            className="summary-card-os-tag"
            i18n={i18n}
            optimizationScore={this.props.optimizationScore}
            newI18n={newI18n}
          />
        }
        <div className="summary-pitching" data-category={this.props.category}>
          <LearnMoreLink
            text={pitching}
            topic={helpId}
            linkText={i18n.getString('LearnMore')}
            linkType={linkType}
            noLink={type === RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATIO}
          />
        </div>
        {showFooterInDescription && footer}
      </div>
    );

    return (
      <div className="recommendation-summary-card">
        {!isOverviewPage && header}
        <div className="summary-summary">
          {!isOverviewPage && inProductUpdateConfig && inProductUpdateConfig.warnNotification &&
          <WarnNotificationBanner
            type={type}
            preferencesService={preferencesService}
            newI18n={newI18n}
            uid={scope.userId}
            cid={scope.advertiserCustomerId}
            aid={scope.accountId}
            isMCC={isMCC}
            isFromSummary={isFromSummary}
            initializeMiniGrid={initializeMiniGrid}
            isAutoApplyOptIn={isAutoApplyOptIn}
          />}
          {!isOverviewPage &&
            isInProductUpdateBannerAvailable(type, permissions, summary) &&
            <InProdUpdateNotificationBanner
              type={type}
              preferencesService={preferencesService}
              i18n={i18n}
              additionalArgs={additionalArgs}
            />}
          {!isOverviewPage && banner}
          <div
            className={`summary-summary-content ${isOptimizationScoreOn ? 'with-optimization-score' : ''}`}
            style={showEstimates ? {} : { gridTemplateColumns: 'auto', msGridColumns: 'auto' }}
          >
            {!isOptimizationScoreOn && !isOverviewPage && showEstimates && summaryEstimates}
            {overviewEstimationOrSummary}
            {summaryDescription}
            {!isOverviewPage && isOptimizationScoreOn && showEstimates && summaryEstimation}
          </div>
        </div>
        {showSummarySample && sample}
        {!showFooterInDescription && !isOverviewPage && footer}
        {showAutoApplyBanner &&
          <AutoApplyBanner
            i18n={i18n}
            cid={scope.advertiserCustomerId}
            aid={scope.accountId}
            newI18n={newI18n}
            optInStatus={optInStatus}
            applyDate={applyDate}
            recommendationsCount={recommendationsCount}
            appConfig={appConfig}
            odata={odata}
            isFromSummary={isFromSummary}
            classes={classes}
            initializeMiniGrid={initializeMiniGrid}
            permissions={this.props.permissions}
            type={type}
            campaignAutoApplyStatus={isAutoApplyRecommendationEnabled ? { [type]: 'true' } : {}}
            isAutoApplyRecommendationEnabled={isAutoApplyRecommendationEnabled}
            viewSettings={viewSettings}
          />}
      </div>
    );
  }
}

export const SummaryCard = withTrack(/* withAll */ true)(summaryCard);
